import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, ButtonBase, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

const PlaybooksList = (props) => {
  const {groupedPlaybooks, onSelectPlaybook, openNew, selectedPlaybookRn} = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minWidth: 0,
        border: '1px solid',
        borderColor: '#E8E4DE',
      }}
    >
      <Stack
        direction='row'
        alignItems='flex-start'
        justifyContent='space-between'
        sx={{
          px: '32px',
          paddingTop: '24px',
          paddingBottom: '12px',
          gap: '112px',
        }}
      >
        <Stack sx={{gap: '8px'}}>
          <Typography
            sx={{
              fontWeight: 400,
              fontStyle: 'Regular',
              fontSize: '17px',
              color: '#1A1916',
              lineHeight: '100%',
            }}
          >
            <Translate expression='playbooks.List.Title' />
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontStyle: 'Regular',
              fontSize: '12px',
              color: '#A8A49E',
              lineHeight: '100%',
              whiteSpace: 'nowrap',
            }}
          >
            <Translate expression='playbooks.List.Subtitle' />
          </Typography>
        </Stack>
        <Button
          onClick={openNew}
          disableElevation
          sx={{
            'borderRadius': '7px',
            'p': '4px',
            'gap': '10px',
            'fontWeight': 500,
            'fontStyle': 'Medium',
            'fontSize': '12px',
            'color': '#FFFFFF',
            'backgroundColor': '#DA7955',
            '&:hover': {
              backgroundColor: '#DA7955',
              boxShadow: 'none',
            },
            'textTransform': 'none',
          }}
        >
          <Translate expression='playbooks.List.NewPlaybook' />
        </Button>
      </Stack>
      <Box sx={{borderBottom: '1px solid #E8E4DE'}}></Box>
      <Stack
        sx={{
          flex: 1,
          px: '16px',
          py: '16px',
          gap: '12px',
          minWidth: 0,
          overflowY: 'auto',
        }}
      >
        {
          groupedPlaybooks.length === 0 &&
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              color: '#A8A49E',
              lineHeight: '150%',
            }}
          >
            <Translate expression='playbooks.List.Empty' />
          </Typography>
        }
        {
          groupedPlaybooks.map((group) => (
            <Stack
              key={group.groupName}
              sx={{
                gap: '8px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '10px',
                  fontWeight: 500,
                  color: '#A8A49E',
                  lineHeight: '100%',
                  textTransform: 'uppercase',
                }}
              >
                {group.groupName}
              </Typography>
              <Stack
              >
                {
                  group.playbooks.map((playbook) => {
                    const isSelected = playbook.playbookRn === selectedPlaybookRn;

                    return (
                      <ButtonBase
                        key={playbook.playbookRn}
                        onClick={() => onSelectPlaybook(playbook)}
                        aria-pressed={isSelected}
                        sx={{
                          'justifyContent': 'flex-start',
                          'px': '8px',
                          'py': '10px',
                          'borderRadius': '8px',
                          'backgroundColor': isSelected ? '#F3F1EE' : 'transparent',
                          '&:hover': {
                            backgroundColor: isSelected ? '#F3F1EE' : '#F8F6F3',
                          },
                          ...(isSelected && {
                            '&::before': {
                              content: '""',
                              position: 'absolute',
                              left: '0',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              width: '4px',
                              height: '18px',
                              borderRadius: '4px',
                              backgroundColor: '#DA7955',
                            },
                          }),
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: '12px',
                            fontWeight: 400,
                            fontStyle: 'Regular',
                            color: isSelected ? '#1A1916' : '#6B6760',
                            lineHeight: '100%',
                          }}
                        >
                        /{playbook.title}
                        </Typography>
                      </ButtonBase>
                    );
                  })
                }
              </Stack>
            </Stack>
          ))
        }
      </Stack>
    </Box>
  );
};

PlaybooksList.propTypes = {
  groupedPlaybooks: PropTypes.array.isRequired,
  onSelectPlaybook: PropTypes.func.isRequired,
  openNew: PropTypes.func.isRequired,
  selectedPlaybookRn: PropTypes.string,
};

export default React.memo(PlaybooksList);
